import { Badge, Button } from "react-bootstrap";
import variables from "../../../styles/utils.module.scss";
import style from "../../../styles/locationSummary.module.scss";
import { useNavigate } from "react-router-dom";
import SuitabilitySummary from "../../../components/SuitabilitySummary";
import { AWS_S3_BASE_URL } from "../../../helpers/utility";
import { TYPE_OF_CARE } from '../../../helpers/constants';
import { ArrowRight, Car, Footprints, House, School } from 'lucide-react';

const imageTileStyle = {
  display: "flex",
  flexGrow: 1,
  flexBasis: 175,
  flexShrink: 0,
  height: 120,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
  marginLeft: 2,
};

export default function LocationSummary({ info, openEnquiryModal, placementId }) {
  const navigate = useNavigate();

  return (
    <div
      style={{
        flexBasis: 330,
        flexGrow: 1,
        flexShrink: 1,
        maxWidth: 375,
        padding: "20px 20px 20px",
        backgroundColor: variables.pureWhite,
      }}
      className="mobile-gap"
    >
      {!info ? (
        <div className="d-flex flex-column">
          <div className="d-flex flex-column flex-grow-1">
            <div className="d-flex flex-row">
              <span style={{ display: "flex", flexGrow: 1 }}>
                <h1 className={"h2"} style={{ fontWeight: "bold" }}>
                  Get Started
                </h1>
              </span>
            </div>

            <p style={{ fontSize: 12, color: "grey" }}>
              Easily find the perfect care provider and make an enquiry through bPlaced. Our filters
              allow you to find the most suitable proivders based on each child's individual needs.
            </p>
          </div>
        </div>
      ) : null}

      {info ? (
        <div className="d-flex flex-column h-100">
          <div className="d-flex flex-column flex-grow-1">
            <div className="d-flex flex-row">
              <span style={{ display: "flex", flexGrow: 1 }}>
                <h1 className={"h2"} style={{ fontWeight: "bold" }}>
                  {info.name}
                  <span style={{ fontSize: 14, color: "grey", fontWeight: "normal", display: "block" }}>
                    {info.address?.addressLine1}
                  </span>
                </h1>
              </span>
              <span style={{ display: "flex", flexGrow: 0 }}>
                <i className="bi bi-star" style={{ color: variables.green, fontSize: 21 }}></i>
              </span>
            </div>

            {info.distance ? (
              <div style={{ fontSize: 16, color: "grey" }}>
                <House size={16} className="me-2" />
                {`${info.distance} miles from home postcode`}
              </div>
            ) : null}
            {info.educationDistance ? (
              <div style={{ fontSize: 16, color: "grey" }}>
                <School size={16} className="me-2" />
                {`${info.educationDistance} miles from education address`}
              </div>
            ) : null}

            {info.driveDuration ? (
              <span style={{ marginLeft: 5, fontSize: 14, color: "grey" }}>
                <Car size={14} className="me-1" />
                ~ {Math.round(info.driveDuration.replace("s", "") / 60)} minutes drive
              </span>
            ) : null}
            {info.driveDuration ? (
              <span style={{ marginLeft: 5, fontSize: 14, color: "grey" }}>
                <Footprints size={14} className="me-1" />
                ~ {Math.round(info.driveDuration.replace("s", "") / 60) * 2.5} minutes walk
              </span>
            ) : null}

            <div className="d-flex flex-row" style={{ overflowX: "scroll", marginBottom: 6 }}>
              {info.galleryURLs?.length > 0
                ? info.galleryURLs?.map((image) => {
                    return (
                      <div
                        key={image.externalId}
                        style={{
                          backgroundImage: `url(${AWS_S3_BASE_URL}/${image.externalId})`,
                          ...imageTileStyle,
                          marginRight: 10,
                          border: "1px solid lightgrey",
                          marginTop: 5,
                          marginBottom: 5,
                        }}
                      />
                    );
                  })
                : null}
            </div>

            <div>
              {info.ofstedReport?.isClosed ? (
                <Badge bg="danger" className={style.badgeSpace}>
                  Closed
                </Badge>
              ) : null}

              {info.ofstedReport?.URN ? (
                <Badge bg="secondary" className={style.badgeSpace}>
                  Regulated
                </Badge>
              ) : null}

              {info.ofstedReport?.inspections?.length > 0 ? (
                <Badge
                  bg="secondary"
                  title={info.ofstedReport?.inspections[0]?.name}
                  className={style.badgeSpace}
                >
                  <a
                    href={info.ofstedReport?.inspections[0]?.link}
                    target="_blank"
                    style={{ color: variables.white }}
                  >
                    Inspected
                    <i
                      className={`bi bi-link-45deg`}
                      style={{
                        fontSize: "12px",
                        marginLeft: "6px",
                        overflowY: "hidden",
                        lineHeight: "10px",
                        height: "10px",
                        display: "inline-block",
                        color: variables.white,
                      }}
                    ></i>
                  </a>
                </Badge>
              ) : null}

              <Badge bg="secondary" className={style.badgeSpace}>
                {info.staffCount} Staff
              </Badge>

              {info.typeOfCare?.length > 0 ? (
                <Badge bg="secondary" className={style.badgeSpace}>
                  {info.typeOfCare.map((type) => TYPE_OF_CARE[type])}
                </Badge>
              ) : null}

              {info.capacityMax - info.capacityUsed < 5 ? (
                <Badge bg="secondary" className={style.badgeSpace}>
                  Limited Availability
                </Badge>
              ) : null}
            </div>

            {info.match ? (
              <SuitabilitySummary match={info.match} wrapperStyle={{ marginTop: 15 }} />
            ) : null}

            <div style={{ marginTop: 15 }}>
              <h4 className="h5">About</h4>
              {info.description?.length > 200
                ? `${info.description?.substr(0, 200)}...`
                : info.description}{" "}
            </div>
          </div>

          <div className="d-flex flex-column flex-shrink-0">
            <Button
              onClick={() => {
                if (typeof openEnquiryModal === "function") {
                  openEnquiryModal(info);
                } else {
                  console.error(`ERROR: missing openModal`);
                }
              }}
            >
              ENQUIRE
            </Button>
            <Button
              variant="outline-secondary"
              style={{ marginTop: 10 }}
              onClick={() => {
                navigate(`/location?locationId=${info?._id}&placementId=${placementId}`);
              }}
            >
              VIEW DETAILS
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  );
}
